import { useRef, useMemo, MutableRefObject } from "react";

import { createContainer } from "./util";

export const useElementRef = (
  containerClassName?: string,
  containerStyle?: Partial<CSSStyleDeclaration>
): MutableRefObject<HTMLDivElement | undefined> => {
  const ref = useRef<HTMLDivElement>();

  ref.current = useMemo(
    () => createContainer(containerStyle, containerClassName),
    [containerClassName, containerStyle]
  );

  return ref;
};
